import { useState, useEffect } from "react";

const useFetch = (url, limit = 10) => {
  const [state, setState] = useState([]);
  console.log(process.env.NODE_ENV)
  console.log('url', url)
  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetch(url);
        console.log("first response", res);
        const resJson = await res.json();
        console.log("seconda", resJson);
        const data = resJson.data.slice(0, limit);
        setState(data);
      } catch (err) {
        throw err;
      }
    }
    fetchData();
  }, [url, limit]);

  return state;
};

export default useFetch;
